<template>
  <div class="!py-3">
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="field-required flex items-start !gap-4">
            <div
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Select Default Field
            </div>
            <div class="form-group flex-1">
              <el-radio v-model="field.default_value" label="YES">YES</el-radio>
              <el-radio v-model="field.default_value" label="NO">NO</el-radio>
              <el-button
                type="Secondary"
                class="w-full box-border !py-1.5 text-xs 2xl:!text-sm text-[#BDBDBD] !border !border-black/20 hover:!brand-100 hover:!border-brand-500 hover:!text-brand-500 active:!brand-100 active:!border-brand-500 active:!text-brand-500 focus:!brand-100 focus:!border-brand-500 focus:!text-brand-500 !font-normal !mt-1"
                @click="field.default_value = ''"
              >
                None Selected
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <div class="mt-2 field-required">
            <el-row :gutter="10">
              <el-col :span="12">
                <is-field-required :field="field" class="field-required" />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="icon-dropdown-selection flex items-center !gap-3">
                  <span
                    class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                  >
                    Icon
                  </span>
                  <el-button type="text" @click="iconPickerdialogVisible = true">
                    <div class="d-flex align-center menu-icon !gap-2">
                      <span>
                        <icons :iconName="templateIconPath"></icons>
                      </span>
                      <i class="el-icon-circle-plus !text-brand-500"></i>
                    </div>
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      id="settingsDialog"
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-YesOrNo',
    props: ['field'],
    components: {
      TitleAndDescription: () => import('./TitleAndDescription.vue'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy.vue'),
    },
    data() {
      return {
        validations: [],
        iconPickerdialogVisible: false,
        templateIconPath: 'dashboard',
      };
    },
    mounted() {
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
    },
  };
</script>

<style lang="scss"></style>
